import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { CheckCircle, X } from '@olxbr/ds-icons'

const variants = {
  valid: {
    color: '--color-feedback-success-110',
    icon: <CheckCircle size="16" />,
  },
  invalid: {
    color: '--color-neutral-120',
    icon: <X size="16" />,
  },
}

const Wrapper = styled.div`
  color: var(${props => variants[props.variant || 'invalid'].color});
  display: flex;
  margin-top: var(--spacing-1);
`

const RuleText = ({ status, children }) => {
  return (
    <Wrapper variant={status}>
      {variants[status].icon}
      <span
        className="typo-caption inline ml-1"
        style={{ color: `var(${variants[status].color})` }}
      >
        {children}
      </span>
    </Wrapper>
  )
}

RuleText.propTypes = {
  children: PropTypes.string,
  status: PropTypes.oneOf(['valid', 'invalid']),
}

export default RuleText
